<template>
    <div>
        <div class="agencyCentre-wrapper teamIncomeOverview-screen trade-refresh">
            <div class="position-relative items-center agencyCentre-headerBar bg-white">
                <div class="angle black-angle" id="close" @click="goToAgencyCenter"></div>
                <div class="text-center agencyCentre-headerHD">Transection History</div>
            </div>
            <div class="py-2">
                <div class="bg-white tradeMain-wrapper trade-transectionHistory">
                    <div class="py-2 trade-transectionHistory-inner">
                        <!-- Initial page loader -->
                         <div v-if="initialLoading">
                            <TradeListSkeleton :rows="5" :lines="5" />
                         </div>
                        <!-- Empty state (after first load) -->
                        <div v-else-if="!error && !txItems.length" class="empty-box">No transactions found.</div>
                        <ul v-else>
                            <li class="mb-2 trade-transectionBox" v-for="(item, idx) in txItems"
                                :key="(item.id || item.wallet_id || 'x') + '-' + (item.created_at || idx) + '-' + idx">
                                <template v-if="item?.userdetails && item?.userdetails?.name">
                                    <div class="d-flex justify-content-between gap-1 trade-transection-inforBoxes">
                                        <div class="trade-transection-inforleftBox">
                                            <div class="sendTo-title">Send To</div>
                                            <div class="trade-userName">Name -
                                                <span class="fw-semibold">{{ item?.userdetails ? item?.userdetails?.name
                                                    : 'N/A' }}</span>
                                            </div>
                                            <div class="d-flex align-items-center trade-userName"
                                                @click="onCopy(item?.userdetails?.profile_id)">ID -
                                                <span class="d-flex align-items-center gap-1 fw-semibold">{{
                                                    item?.userdetails ?
                                                    item?.userdetails?.profile_id : 'N/A' }}
                                                    <img :src='copyIcon' alt="" />
                                                </span>
                                            </div>
                                            <div>{{ formatCreatedAtLine(item.created_at) }}</div>
                                            <div>Selling Price - <span class="fw-semibold">₹{{ item?.amount }}</span>
                                            </div>
                                            <div>Remaining Diamonds - <span class="fw-semibold">{{ item?.points
                                            }}</span></div>
                                        </div>
                                        <div
                                            class="d-flex flex-column justify-content-between trade-transection-inforrightBox">
                                            <div class="d-flex justify-content-end align-items-center gap-1 pt-2">
                                                <div class="fw-semibold trade-amount">-{{ item?.debit > 0 ? item?.debit
                                                    :
                                                    item?.credit }}</div>
                                                <img :src='diamondIcon' class="m-0 diamondIcon" alt="" />
                                            </div>
                                            <!-- Otherwise, when pending === 1 -->
                                            <div v-if="[1, 2].includes(Number(item.pending))"
                                                :class="Number(item.pending) === 1 ? 'bg-white text-center trade-activBtn' : 'bg-white text-center trade-activBtn trade-recallBtn'">
                                                {{ Number(item.pending) === 1 ? 'Activated' : 'Recalled' }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="d-flex justify-content-between gap-1 trade-transection-inforBoxes">
                                        <div class="trade-transection-inforleftBox">
                                            <div class="fw-semibold trade-userName">Name - {{ item?.status || 'N/A' }}</div>
                                            <div>{{ formatCreatedAtLine(item.created_at) }}</div>
                                            <div>Selling Price - <span class="fw-semibold"></span></div>
                                        </div>
                                        <div
                                            class="d-flex flex-column justify-content-between trade-transection-inforrightBox">
                                            <div class="d-flex justify-content-end align-items-center gap-1 pt-2">
                                                <div class="bg-white text-center trade-activBtn">+ {{ item?.credit > 0 ?
                                                    item?.credit : item?.credit }}</div>
                                                <img :src='diamondIcon' class="m-0 diamondIcon" alt="" />
                                            </div>
                                            <div class="bg-white text-center trade-activBtn">Activated</div>
                                        </div>
                                    </div>
                                </template>
                                <!-- When pending === 0 -->
                                <template v-if="Number(item.pending) === 0">
                                    <div
                                        class="mt-3 d-flex justify-content-center align-items-center gap-4 confirm-popupBtn">
                                        <button type="button" class="trade-btn trade-primary-btn"
                                            :disabled="actionLoadingId === item.id"
                                            @click="updateTransfer('activate', item)"> {{ isLoading(item, 'activate') ?
                                                'Activating...' : 'Activate' }}</button>
                                        <button type="button" class="trade-btn" :disabled="actionLoadingId === item.id"
                                            @click="updateTransfer('recall', item)"> {{ isLoading(item, 'recall') ?
                                                'Recalling...' : 'Recall' }}</button>
                                    </div>
                                    <div class="text-center mt-2 tipsForActive-title">
                                        Click here after confirmation with the receiver
                                    </div>
                                </template>
                            </li>
                        </ul>
                        <!-- Infinite scroll sentinel -->
                        <div ref="sentinel" class="infinite-sentinel" aria-hidden="true"></div>
                        <!-- Bottom loader (next page) -->
                        <div v-if="pagingLoading" class="paging-loader" aria-live="polite">
                            <span>Loading more…</span>
                        </div>
                        <!-- Error -->
                        <div v-if="error" class="error-box">
                            {{ error }}
                            <button class="retry-btn" @click="retryFromHere">Retry</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- simple copied popup -->
        <div v-if="showCopyPopup" class="copy-popup">
            ID Copied!
        </div>
    </div>
</template>
<script>
import axios from "axios";
import './TradeAccount.css';
import './TradeRefresh.css'
import diamondIcon from '../../assets/images/diamond-icon.png';
import copyIcon from '../../assets/images/copy_icon.svg';
import TradeListSkeleton from "./TradeListSkeleton.vue";

export default {
    name: 'TradeTransectionHistory',
    components: {
        TradeListSkeleton
    },
    data() {
        return {
            diamondIcon,
            copyIcon,
            actionLoadingId: null,
            actionLoadingType: null,
            token: '',

            // list & paging
            txItems: [],
            page: 0,
            pageSize: 10,
            hasMore: true,
            // loaders & error
            initialLoading: false,
            pagingLoading: false,
            error: '',
            io: null, // IntersectionObserver
            showCopyPopup: false,
            loading: false,
        };
    },
    mounted() {
        this.token = sessionStorage.getItem("tradeAcountToken") || '';
        this.bootstrap();
    },

    unmounted() { this.destroyObserver() },
    beforeUnmounted() { this.destroyObserver() },
    methods: {
        async bootstrap() {
            this.destroyObserver();
            this.loading = true;
            this.initialLoading = true;
            this.pagingLoading = false;
            this.error = '';
            this.txItems = [];
            this.page = 0;
            this.hasMore = true;

            try {
                await this.loadMore(true);
                this.$nextTick(this.initObserver);
            } catch (e) {
                console.error('bootstrap error:', e);
                this.error = 'Failed to load transactions.';
            } finally {
                this.initialLoading = false;
                this.loading = false;
            }
        },

        /* Infinite scroll*/
        initObserver() {
            const sentinel = this.$refs.sentinel;
            if (!sentinel) return;
            if (this.io) { this.io.disconnect(); this.io = null; }
            const rootEl = null;
            this.io = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (entry?.isIntersecting && !this.pagingLoading && this.hasMore) {
                    this.loadMore();
                }
            }, { root: rootEl, rootMargin: '0px 0px 200px 0px', threshold: 0 });
            this.io.observe(sentinel);
            this.$nextTick(() => {
                const root = rootEl || document.documentElement;
                const canScroll = root.scrollHeight > root.clientHeight;
                if (!canScroll && this.hasMore && !this.pagingLoading) {
                    this.loadMore();
                }
            });
        },
        destroyObserver() {
            if (this.io) { this.io.disconnect(); this.io = null; }
        },

        /* Server paging */
        async loadMore(initial = false) {
            if (!this.hasMore || this.pagingLoading) return;
            this.pagingLoading = !initial;
            this.error = '';
            try {
                const nextPage = this.page + 1;
                const url = 'api/wallet-history-tradeaccount';
                const { data } = await axios.get(url, {
                    headers: { Accept: 'application/json', Authorization: `Bearer ${this.token}` },
                    params: { page: nextPage, per_page: this.pageSize }
                });

                const raw = data?.result ?? data ?? {};
                let items =
                    raw.data ??
                    raw.items ??
                    raw.list ??
                    raw.records ??
                    (Array.isArray(raw) ? raw : []);

                if (!Array.isArray(items) && Array.isArray(raw?.data?.data)) {
                    items = raw.data.data;
                }
                items = Array.isArray(items) ? items : [];

                // Update list
                this.txItems = this.txItems.concat(items);

                // Detect "has more"
                const currentPage = raw.current_page ?? raw.meta?.current_page ?? nextPage;
                const lastPage = raw.last_page ?? raw.meta?.last_page;
                const nextUrl = raw.next_page_url ?? raw.links?.next;
                const perPage = raw.per_page ?? raw.meta?.per_page ?? this.pageSize;

                let more = true;
                if (typeof lastPage === 'number') more = currentPage < lastPage;
                else if (nextUrl !== undefined) more = !!nextUrl;
                else more = items.length === perPage;

                this.hasMore = more;
                this.page = nextPage;
            } catch (e) {
                console.error('loadMore error:', e);
                this.error = 'Could not load more transactions.';
            } finally {
                this.pagingLoading = false;
            }
        },

        retryFromHere() {
            if (!this.txItems.length) this.bootstrap();
            else this.loadMore(false);
        },
        //   helpers
        goToAgencyCenter() {
            this.$router.go(-1);
        },
        isLoading(item, type) {
            return this.actionLoadingId === item.id && this.actionLoadingType === type;
        },
        async updateTransfer(type, item) {
            // type must be 'activate' or 'recall'
            const walletId = item.wallet_id ?? item.id;
            if (!walletId) return console.error("Missing wallet_id");

            this.actionLoadingId = item.id;
            this.actionLoadingType = type;

            try {
                const res = await axios.post('api/updatetransferdetails',
                    { type, wallet_id: walletId },
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${this.token}`,
                        },
                    }
                );

                const ok = res?.data?.status === true || res?.data?.success === true || res?.success === true || res?.status === 200;
                if (ok) {
                    item.pending = type === "activate" ? 1 : 0;
                    // Refresh the list from the server and re-page
                    await this.bootstrap();
                } else {
                    console.warn("Update failed:", res?.data);
                }
            } catch (err) {
                console.error("updatetransferdetails error:", err);
            } finally {
                this.actionLoadingId = null;
                this.actionLoadingType = null;
            }
        },
        formatCreatedAt(ct) {
            if (!ct) return { date: '—', time: '—' };
            const str = String(ct).trim();
            const [rawDate, rawTime] = str.split(/\s+/); // e.g. "22-08-2025" & "18:11:45"
            if (!rawDate || !rawTime) return { date: '—', time: '—' };

            // Handle "DD-MM-YYYY" or "YYYY-MM-DD" defensively
            const parts = rawDate.split('-');
            let day, month, year;
            if (parts.length === 3) {
                if (parts[0].length === 2 && parts[2].length === 4) {
                    [day, month, year] = parts;
                } else if (parts[0].length === 4) {
                    [year, month, day] = parts;
                } else {
                    return { date: rawDate, time: rawTime };
                }
            } else {
                return { date: rawDate, time: rawTime };
            }

            const pad = (x) => x.toString().padStart(2, '0');
            const date = `${pad(day)}-${pad(month)}-${year}`;

            const [hh = '00', mm = '00', ss = '00'] = rawTime.split(':');
            const time = `${pad(hh)}:${pad(mm)}:${pad(ss).slice(0, 2)}`;

            return { date, time };
        },

        formatCreatedAtLine(ct) {
            const { date, time } = this.formatCreatedAt(ct);
            return `Date:- ${date}, Time:- ${time}`;
        },
        // ---------- Clipboard (moved inside methods) ----------
    async onCopy(profileId) {
        if (!profileId) return;
        const text = String(profileId);

        const copySuccess = () => {
            this.showCopyPopup = true;
            setTimeout(() => {
                this.showCopyPopup = false;
            }, 2000);
        };

        if (navigator?.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                copySuccess();
            } catch (err) {
                console.error("Clipboard API failed:", err);
                this.fallbackCopyText(text, copySuccess);
            }
        } else {
            this.fallbackCopyText(text, copySuccess);
        }
    },

    fallbackCopyText(text, callback) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy");
            callback?.();
        } catch (err) {
            console.error("Fallback copy failed:", err);
        }
        document.body.removeChild(textarea);
    },
    // ---------- Clipboard ----------
    },    
}
</script>